import React, { useState } from 'react';

import { MobileMenuWrapper, FloatingButton, NavItemMobile as NavItem, NavItemsBottomNav } from './NavMobile.style';

import NavLinks from './NavLinks';
import Burger from './Burger';

const NavbarMobile = () => {
  const [isMenuOpen, setMenu] = useState(false);

  const handleMenuState = () => {
    setMenu(!isMenuOpen);
  };

  return (
    <>
      <MobileMenuWrapper>
        <FloatingButton onClick={handleMenuState} as="button">
          <Burger isActive={isMenuOpen} />
        </FloatingButton>

        <NavItemsBottomNav isOpen={isMenuOpen}>
          <NavLinks NavItem={NavItem} />
        </NavItemsBottomNav>
      </MobileMenuWrapper>
    </>
  );
};

export default NavbarMobile;
